export enum EventConfigurationKeys {
  Reception = 'reception',
  Schedule = 'schedule',
  MainStage = 'mainStage',
  Sessions = 'sessions',
  Posters = 'posters',
  Expo = 'expo',
  Community = 'community',
  Lounge = 'lounge',
  Helpdesk = 'helpdesk',
}
